"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
exports.FeatureFlag = {
    CONSOLIDATED_LTL: 'CONSOLIDATED_LTL',
    EXTENDED_CONSOLIDATED_LEG: 'EXTENDED_CONSOLIDATED_LEG',
    USE_INTERNAL_RATES: 'USE_INTERNAL_RATES',
    TEST_FLAG: 'TEST_FLAG',
    TEST_FLAG_2: 'TEST_FLAG_2'
};
//# sourceMappingURL=feature-flag.js.map